import { useLocation } from 'react-router-dom';
import { useHandleResize } from '../../utils/handleResize';

export const useNavMenuState = () => {
  const location = useLocation();
  const { width } = useHandleResize();
  const path = location?.pathname || '/';
  const activeKeys = path
    .replace('/', '')
    .split('/')
    .map((p) => `/${p}`);

  return { path, activeKeys, width };
};
